import { useEffect } from "react";
import Button from "../components/general/Button";
import { useNavigate } from "react-router-dom";
import { auth, signInWithGoogle } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { useZustand } from "../zustand/store";
import { ownerData } from "../data/main.data";
import MadeByOlaBanner from "../components/BottomBanner/MadeByOlaBanner";

function Login() {
  const { loginDescription, setLoginDescription } = useZustand();

  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (
      user?.email === "olaoluwaadeyemo7@gmail.com" ||
      user?.email === ownerData.signInEmail
    ) {
      setLoginDescription("");
      navigate("/dashboard");
    } else {
      setLoginDescription("You don't look like him!");
    }
  }, [user]);

  return (
    <div className="w-full min-h-screen flex flex-col justify-center items-center">
      <h1 className="text-3xl md:text-5xl font-black text-black font-boska text-center">
        For {ownerData.actualName} Only!
      </h1>
      <p className="text-xl md:text-3xl font-light text-black font-boska text-center mt-3">
        {loginDescription}
      </p>
      <div className="flex justify-center items-center gap-5">
        <Button text="Login With Google" onClick={() => signInWithGoogle()} />
        <Button text="Home" onClick={() => navigate("/")} />
      </div>
      <div className="flex justify-center pt-2">
       <MadeByOlaBanner />
       </div>
    </div>
  );
}

export default Login;
